export default "__VITE_ASSET__DgRRWC$t__"